import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  baseLayerChanged,
  parkAndRideToggled,
  realtimeVehiclesToggled as realtimeVehiclesToggledAction,
  rentalCompanyIncluded,
  rentalCompanyExcluded,
  routeLayerIncluded,
  routeLayerExcluded,
  alwaysShowMapControlsToggled,
} from '#/map/slice';
import {
  STREETS_BASE_LAYER,
  AERIALS_BASE_LAYER,
  ROUTES_BASE_LAYER,
  ROUTES_AERIALS_BASE_LAYER,
  THREE_DIMENSIONAL_LAYER,
  ROUTES_THREE_DIMENSIONAL_LAYER,
} from '#/map/constants';
import { BASE_LAYER_STORAGE_KEY } from '#/shared/constants';
import { storeItem } from '#/shared/utils/storage';

export default () => {
  const dispatch = useDispatch();

  const setBaseLayerStreets = useCallback(() => {
    dispatch(baseLayerChanged(STREETS_BASE_LAYER));
    storeItem(BASE_LAYER_STORAGE_KEY, STREETS_BASE_LAYER);
  }, [dispatch]);
  const setBaseLayerAerials = useCallback(() => {
    dispatch(baseLayerChanged(AERIALS_BASE_LAYER));
    storeItem(BASE_LAYER_STORAGE_KEY, AERIALS_BASE_LAYER);
  }, [dispatch]);

  const setBaseLayerRoutes = useCallback(() => {
    dispatch(baseLayerChanged(ROUTES_BASE_LAYER));
    storeItem(BASE_LAYER_STORAGE_KEY, ROUTES_BASE_LAYER);
  }, [dispatch]);

  const setBaseLayerRoutesAerials = useCallback(() => {
    dispatch(baseLayerChanged(ROUTES_AERIALS_BASE_LAYER));
    storeItem(BASE_LAYER_STORAGE_KEY, ROUTES_AERIALS_BASE_LAYER);
  }, [dispatch]);

  const setBaseLayerRoutesThreeDimensional = useCallback(() => {
    dispatch(baseLayerChanged(ROUTES_THREE_DIMENSIONAL_LAYER));
    storeItem(BASE_LAYER_STORAGE_KEY, ROUTES_THREE_DIMENSIONAL_LAYER);
  }, [dispatch]);

  const setBaseLayerThreeDimensional = useCallback(() => {
    dispatch(baseLayerChanged(THREE_DIMENSIONAL_LAYER));
    storeItem(BASE_LAYER_STORAGE_KEY, THREE_DIMENSIONAL_LAYER);
  }, [dispatch]);

  const companies = useSelector(s => s.map.companies);
  const routeLayers = useSelector(s => s.map.routeLayers);

  const toggleRentalCompany = useCallback(
    company => {
      if (companies.includes(company)) {
        dispatch(rentalCompanyExcluded(company));
      } else {
        dispatch(rentalCompanyIncluded(company));
      }
    },
    [dispatch, companies]
  );

  const toggleRouteLayers = useCallback(
    layer => {
      if (routeLayers.includes(layer)) {
        dispatch(routeLayerExcluded(layer));
      } else {
        dispatch(routeLayerIncluded(layer));
      }
    },
    [dispatch, routeLayers]
  );

  const toggleParkAndRide = useCallback(() => {
    dispatch(parkAndRideToggled());
  }, [dispatch]);

  const toggleRealtimeVehicles = useCallback(() => {
    dispatch(realtimeVehiclesToggledAction());
  }, [dispatch]);

  const toggleAlwaysShowMapControls = useCallback(() => {
    dispatch(alwaysShowMapControlsToggled());
  }, [dispatch]);

  const { realtimeVehiclesToggled } = useSelector(s => s.map);

  return {
    companies,
    routeLayers,
    setBaseLayerStreets,
    setBaseLayerAerials,
    setBaseLayerRoutes,
    setBaseLayerRoutesAerials,
    setBaseLayerRoutesThreeDimensional,
    setBaseLayerThreeDimensional,
    realtimeVehiclesToggled,
    toggleRentalCompany,
    toggleParkAndRide,
    toggleRealtimeVehicles,
    toggleRouteLayers,
    toggleAlwaysShowMapControls,
  };
};
